import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CodesaResponseData } from '@core/response/codesa-reponse-data';
import { CodesaResponseList } from '@core/response/codesa-reponse-list';
import { ServiceBase } from '@core/services/service-base';
import { ConfigPresorteo } from '../../models/config-pesorteo.model';

const service = 'coreService';

@Injectable({
  providedIn: 'root'
})
export class ConfigPresorteoService extends ServiceBase {

  constructor(
    private http: HttpClient
  ) {
    super(service);
  }

  getConfigPresorteos(): Promise<CodesaResponseList<ConfigPresorteo>> {
    return this.http.get(`${this.url}/admin/config-presorteo`).toPromise();
  }

  getConfigPresorteo(id: number): Promise<CodesaResponseData<ConfigPresorteo>> {
    return this.http.get(`${this.url}/admin/config-presorteo/${id}`).toPromise();
  }

  postConfigPresorteo(request: ConfigPresorteo): Promise<CodesaResponseData<ConfigPresorteo>> {
    return this.http.post(`${this.url}/admin/config-presorteo`, JSON.stringify(request)).toPromise();
  }
  putConfigPresorteo(request: ConfigPresorteo): Promise<CodesaResponseData<ConfigPresorteo>> {
    return this.http.put(`${this.url}/admin/config-presorteo`, JSON.stringify(request)).toPromise();
  }
}
